import Home from './Home';
import Chapter from './Chapter';
import ScrollToTop from './ScrollToTop';
import NotFound from './NotFound';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

export default function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop>
          <Routes>
            <Route path="*" element={
              <NotFound />
            } />
            <Route path="/" element={
              <Home />
            } />
            <Route path="/chapter1" element={
              <Chapter text="Down the Rabbit-hole" />
            } />
            <Route path="/chapter2" element={
                <Chapter text="The Pool of Tears" />
            } />
            <Route path="/chapter3" element={
                <Chapter text="A Caucus-race and a Long Tale" />
            } />
            <Route path="/chapter4" element={
                <Chapter text="The Rabbit sends in a Little Bill" />
            } />
            <Route path="/chapter5" element={
                <Chapter text="Advice from a Caterpillar" />
            } />
            <Route path="/chapter6" element={
                <Chapter text="Pig and Pepper" />
            } />
            <Route path="/chapter7" element={
                <Chapter text="A Mad Tea-party" />
            } />
            <Route path="/chapter8" element={
                <Chapter text="The Queen's Croquet-ground" />
            } />
            <Route path="/chapter9" element={
                <Chapter text="The Mock Turtle's Story" />
            } />
            <Route path="/chapter10" element={
                <Chapter text="The Lobster Quadrille" />
            } />
            <Route path="/chapter11" element={
                <Chapter text="Who Stole the Tarts?" />
            } />
            <Route path="/chapter12" element={
                <Chapter text="Alice's Evidence" />
            } />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </>
  );
}
